/**
 * Liefert die Zone, in der ein Punkt (Tile-Koordinaten) liegt — oder null.
 * Bei Ueberlappung gewinnt die zuerst definierte Zone (Editor-Reihenfolge).
 */
export function zoneAt(zones, x, y) {
    for (const zone of zones) {
        for (const r of zone.rects) {
            if (x >= r.x && x < r.x + r.w && y >= r.y && y < r.y + r.h)
                return zone;
        }
    }
    return null;
}
/**
 * Ordnet Spieler ihren Zonen zu (fuer Raumschilder und Konferenz-Banner).
 * Rueckgabe: zoneId -> Spieler in dieser Zone (zoneAt-Prioritaet gilt).
 */
export function zoneOccupancy(zones, players) {
    const result = new Map();
    for (const player of players) {
        const zone = zoneAt(zones, player.x, player.y);
        if (!zone)
            continue;
        const list = result.get(zone.id);
        if (list)
            list.push(player);
        else
            result.set(zone.id, [player]);
    }
    return result;
}
/**
 * Ermittelt, welche restricted-Zonen ein Benutzer NICHT betreten darf.
 * Admins duerfen ueberall hin (leere Liste). Sonst: jede restricted-Zone,
 * fuer die der Benutzer nicht freigeschaltet ist.
 */
export function deniedZoneIdsFor(zones, userId, isAdmin, allowedUsersByZone) {
    if (isAdmin)
        return [];
    const denied = [];
    for (const zone of zones) {
        if (!zone.restricted)
            continue;
        if (!(allowedUsersByZone[zone.id] ?? []).includes(userId))
            denied.push(zone.id);
    }
    return denied;
}
/** Quadrat der euklidischen Distanz (vermeidet sqrt in heissen Pfaden). */
export function distanceSquared(ax, ay, bx, by) {
    const dx = ax - bx;
    const dy = ay - by;
    return dx * dx + dy * dy;
}
//# sourceMappingURL=zones.js.map